import PlanCheckIcon from "../../../../assets/planCheckIcon.svg";
import PlanTooltipIcon from "../../../../assets/planTooltipIcon.svg";
import "./Benefits.css";

const Benefits = ({ benefits }) => {

  if (!benefits || benefits.length == 0) {
    return  <></>
  }

  return (
    <div className="benefitsList">
      {benefits.map((benefit, index) => {
          const benefitText = typeof benefit === 'string'
            ? benefit
            : benefit?.title || benefit?.description || '';

          return (
            <div key={benefit?.id || index} className="benefitItem">
              <img src={PlanCheckIcon} alt="Plan Check Icon" className="planCheckIcon" width={16} height={16} />
              <span className="benefitText">{benefitText}</span>
              {benefit.description && (
                <div className="tooltipContainer">
                  <img src={PlanTooltipIcon} alt="Plan Tooltip Icon" className="planTooltipIcon" width={13} height={13} />
                  <div className="tooltipContent">
                    {benefit.description}
                  </div>
                </div>
              )}
            </div>
          );
      })}
    </div>
  );
}

export default Benefits;
